import React from 'react';
import { openSupportChat } from 'services/support_chat';

const DisabledService = () => {
  return (
    <div className="container" id="main">
      <div className="row text-center justify-content-center align-items-center">
        <div className="col-md-9 col-12">
          <div className="card mt-5">
            <div className="card-body">
              <div id="notfound">
                <h4>Este recurso não esta ativo para sua assinatura.</h4>
                <h5 className="my-3">
                  Entre em contato com um de nossos consultores para que possamos ajudá-lo.
                </h5>
                <button className="btn btn-info" onClick={() => openSupportChat()} type="button">
                  Atendimento pelo chat
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisabledService;
